module.exports = __webpack_public_path__ + "img/82.711ce99c.jpg";